import { pick } from 'lodash';
import AsyncValidator from 'async-validator'
import store from '@/store';
import tracking from '@/aspects/trackings';
export const generateCheckoutTileList = (checkoutTileMap) => {
  const checkoutTileList = [
    {isActive: false, current: checkoutTileMap.signUp, next: checkoutTileMap.address},
    {isActive: false, current: checkoutTileMap.address, next: checkoutTileMap.payment},
    {isActive: false, current: checkoutTileMap.payment, next: ''},
  ];

  const checkoutTileListPhone = [
    {isActive: false, current: checkoutTileMap.signUp, next: checkoutTileMap.smsVerify},
    {isActive: false, current: checkoutTileMap.address, next: checkoutTileMap.payment},
    {isActive: false, current: checkoutTileMap.payment, next: ''},
    {isActive: false, current: checkoutTileMap.smsVerify, next: checkoutTileMap.address},
  ];

  const checkoutTileListInr = [
    {isActive: false, current: checkoutTileMap.signUp, next: checkoutTileMap.address},
    {isActive: false, current: checkoutTileMap.address, next: checkoutTileMap.payment},
    {isActive: false, current: checkoutTileMap.payment, next: ''},
  ];

  const checkoutTileListZeZsForIndia = [
    {isActive: false, current: checkoutTileMap.signUp, next: checkoutTileMap.address},
    {isActive: false, current: checkoutTileMap.address, next: checkoutTileMap.useVerification},
    {isActive: false, current: checkoutTileMap.payment, next: ''},
    {isActive: false, current: checkoutTileMap.useVerification, next: checkoutTileMap.payment}
  ]
  return {
    checkoutTileList,
    checkoutTileListPhone,
    checkoutTileListInr,
    checkoutTileListZeZsForIndia
  }
}

export const generateGAbizInfo = (isArr = true) => {
  try {
    const getters = store.getters;
    const { addressInfo , countryList } = getters;
    const { employeeCount,accountHq ,usageType} = addressInfo
    const country = countryList.find(country => country.value === accountHq)?.label || accountHq
    return isArr? [
      usageType,
      employeeCount,
      country
    ]:{
      'businessPersonalAccount':		usageType,
      'businessSize': employeeCount,
      'businessRegion': country,
    }
  } catch {
    return isArr? [] : {}
  }
}

export const sendGAbizInfo = (buyInteraction, buySelection ) => {
    try{
      const getters = store.getters;
      const { persistState } = getters;
      const { accountBizInfo } = persistState
      const {
        businessPersonalAccount,
        businessSize,
        businessRegion 
      } = accountBizInfo
      tracking.buyInteractionWithBizInfo(
        buyInteraction, buySelection,
        businessPersonalAccount,
        businessSize,
        businessRegion);
    } catch (e) {
      console.log(e);
    }
}

/**
 * get first scrollable parent of ele
 * @param {object} ele
 * @returns element
 */
export const getFirstScrollableParent = (ele) => {
  let targetEle = ele.parentElement;
  while (targetEle) {
    const style = window.getComputedStyle(targetEle);
    const overflowRegex = /(auto|scroll)/;
    if (
      overflowRegex.test(`${style.overflow};${style.overflowY}`) &&
      targetEle.scrollHeight > targetEle.clientHeight
    ) {
      return targetEle;
    }
    targetEle = targetEle.parentElement;
  }
  return document.documentElement;
};

/**
 * scroll to the top of view
 * @param {object} ele Element
 */
export const scrollToTop = (ele) => {
  const scrollableParent = getFirstScrollableParent(ele);
  let topOffset = scrollableParent.getBoundingClientRect().top;
  if (scrollableParent === document.documentElement) {
    // offset of mobile view top
    const opcHead = document.querySelector('#new_buyflow_header_container');
    const opcDrawer = document.querySelector('#the-main-content .opc-layout__layer__inner');
    topOffset = opcHead && opcDrawer ? opcHead.offsetHeight + opcDrawer.offsetHeight : 100;
  }
  const scrollOffset = ele.getBoundingClientRect().top - topOffset - 8;
  scrollableParent.scrollTo({
    top: scrollableParent.scrollTop + scrollOffset,
    behavior: 'smooth',
  });
};

/**
 * focus on form field
 * @param {object} field Component
 */
export const focusFormField = (field) => {
  // use BFS find first node that can be focused
  const queue = [...field.$children];
  while (queue.length > 0) {
    const current = queue.shift();
    if (current && typeof current.focus === 'function') {
      current.focus();
      return;
    }
    queue.push(...current.$children);
  }
};

/**
 * validate form without any error message pop up
 * @param {object} formRef
 * @param {(errors: object[], fields: object) => void} [callback]
 * @returns {Promise} PROMISE USAGE: without callback
 */
export const silentValidateForm = (formRef, callback) => {
  const props = formRef.fields.map((field) => field.prop);
  const rules = pick(formRef.rules, props);
  const validator = new AsyncValidator(rules);
  if (typeof callback === 'function') {
    validator.validate(formRef.model, callback);
    return;
  }
  // use as Promise
  return new Promise((resolve, reject) => {
    validator.validate(formRef.model, (errors, fields) => {
      if (errors) {
        reject({ errors, fields });
      } else {
        resolve();
      }
    });
  });
};
